module.exports = __webpack_public_path__ + "static/img/doc.e7432caf.png";